function confirmDeleteTaskDocumentDialogDirective () {
  return {
    retrict: 'E',
    templateUrl: '/workflow/dialogs/confirm-delete-task-document/confirm-delete-task-document-dialog.html?$$REVISION$$'
  }
}

export { confirmDeleteTaskDocumentDialogDirective }
